import { useMutation } from '@tanstack/react-query';
import { createShoppingCart } from '../api/client';

export const useCreateCart = () => {
    const { mutateAsync: createCart } = useMutation({
        mutationFn: ({ ProductOffer, productId, specialApps }: { ProductOffer: any, productId: any, specialApps: any }) => {
            return createShoppingCart({ ProductOffer, productId, specialApps });
        },
    });

    return createCart;
}